import { parsePhoneNumber } from "react-phone-number-input"

export function formatPhoneNumber(phoneNumber: string) {
  const parsedPhoneNumber = parsePhoneNumber(phoneNumber)

  if (parsedPhoneNumber) {
    return `+${parsedPhoneNumber.countryCallingCode} ${parsedPhoneNumber.formatNational()}`
  }

  return phoneNumber
}
